import {
  Users,
  Calculator,
  ClipboardCheck,
  FileText,
  UserCircle,
  CheckCircle2,
  ShieldCheck,
  SlidersHorizontal,
  Receipt,
  BarChart3,
  Lock,
  Clock,
  Briefcase,
  Coins,
  ClipboardList,
  Mail,
  FolderOpen,
  LineChart,
  Sparkles,
} from "lucide-react";
import FeaturePageLayout from "./FeaturePageLayout";
import payrollAutomationHero from "../../assets/images/features/payroll-automation-hero.png";

const workflowSteps = [
  { id: 1, title: "Collect Data", desc: "Attendance, leaves & salary details are collected.", icon: Users },
  { id: 2, title: "Calculate Payroll", desc: "System calculates earnings, deductions, overtime, taxes, etc.", icon: Calculator },
  { id: 3, title: "Review & Approve", desc: "Payroll admins review and approve payroll before finalization.", icon: ClipboardCheck },
  { id: 4, title: "Generate Payslips", desc: "Payslips are generated instantly for all employees.", icon: FileText },
  { id: 5, title: "Employee Access", desc: "Employees can download payslips via ESS portal.", icon: UserCircle },
];

const keyBenefits = [
  { title: "Automated salary calculations", desc: "Accurate calculations of earnings, deductions, overtime, bonuses and taxes.", icon: Calculator },
  { title: "Error-free payroll processing", desc: "Eliminate manual errors and ensure 100% accuracy in payroll.", icon: CheckCircle2 },
  { title: "Statutory compliance", desc: "Automatic calculation of PF, ESI, PT, TDS and other statutory deductions.", icon: ShieldCheck },
  { title: "Custom salary structures", desc: "Create flexible salary components as per your company policies.", icon: SlidersHorizontal },
  { title: "Instant payslip generation", desc: "Generate and distribute payslips instantly.", icon: Receipt },
  { title: "Payroll reports & analytics", desc: "Detailed reports and insights for better decision making.", icon: BarChart3 },
  { title: "Secure employee payroll records", desc: "All payroll data is securely stored and easily accessible.", icon: Lock },
  { title: "Faster monthly payroll processing", desc: "Save time and process payroll in just a few clicks.", icon: Clock },
];

const whatsIncluded = [
  { title: "Salary Components", desc: "Basic, Allowances, Incentives & Custom Components", icon: Briefcase },
  { title: "Attendance Integration", desc: "Auto-sync attendance & leave data", icon: Users },
  { title: "Statutory Deductions", desc: "PF, ESI, PT, TDS & other applicable deductions", icon: Coins },
  { title: "Payroll Review", desc: "Review payroll before final approval", icon: ClipboardList },
  { title: "Payslip Distribution", desc: "Share payslips via ESS portal or email", icon: Mail },
  { title: "Payroll History", desc: "Complete payroll history for audits & reference", icon: FolderOpen },
  { title: "Reports & Analytics", desc: "Payroll summary, cost analysis & statutory reports", icon: LineChart },
  { title: "Data Security", desc: "Secure, role-based access to payroll data", icon: ShieldCheck },
];

export default function PayrollAutomation() {
  return (
    <FeaturePageLayout
      featureName="Payroll Automation"
      title="Payroll Automation"
      subtitle="Automate your entire payroll process with accuracy, compliance and ease."
      description="Payroll Automation simplifies the entire salary processing workflow by eliminating manual calculations and reducing errors. With Brixigo, organizations can process payroll quickly, accurately, and in compliance with statutory regulations."
      heroImage={payrollAutomationHero}
      heroImageAlt="Payroll automation — invoice, calculator and salary illustration"
      workflowHeading="How Payroll Automation Works"
      workflowSteps={workflowSteps}
      benefits={keyBenefits}
      included={whatsIncluded}
      ctaIcon={Sparkles}
      ctaTitle="Simplify Payroll. Save Time. Stay Compliant."
      ctaDescription="Automate your payroll process and focus on what matters most – your people and your business."
      ctaButtonLabel="Book a Demo"
    />
  );
}
